import { assoc, compose, pick } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'
import { useModalData } from '../../../../../components/modals/ModalsContext'
import Form from '../../../../../packages/kiti/components/form/form/Form'
import FormItem from '../../../../../packages/kiti/components/form/form/FormItem'
import SubmitBar from '../../../../../packages/kiti/components/form/SubmitBar'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import { useSaveIntegrations } from '../../_requests/saveIntegrations'

const cleanRequest = form => {
  return compose(
    pick(['id', 'service', 'name', 'token', 'extra_data']), //
    item => assoc('name', 'Twilio', item),
    item => assoc('service', 'TWILIO', item),
    item => assoc('token', `${item.accountSid}:${item.authToken}`, item),
    item => assoc('extra_data', `{ \"myTwilioPhone\": ${item.myTwilioPhone} }`, item)
  )(form)
}

const FormTwilio = ({ integrationId, moveBackOnSuccess, ...props }) => {
  const { t } = useTranslation('listIntegrations')
  const [save, { loading, error }] = useSaveIntegrations(cleanRequest, moveBackOnSuccess)

  return (
    <Form initialState={{ id: integrationId, service: 'twilio' }} onSubmit={save}>
      <FormItem label={t('twilio.accountSid')} field="accountSid" />
      <Separator weight={2} />
      <FormItem label={t('twilio.authToken')} field="authToken" />
      <Separator weight={2} />
      <FormItem label={t('twilio.myTwilioPhone')} field="myTwilioPhone" />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default FormTwilio
